export enum PAGE_LANGUAGE {
    english = 'en',
    spanish = 'es'
}

export const DEFAULT_PAGE: TDDPage = {
    attribute: {
        isPageLoadVariables: true
    },
    category: {
        pageType: '',
        primaryCategory: '',
        subCategory: ''
    },
    pageInfo: {
        language: window.location.hostname === 'es.xfinity.com' ? PAGE_LANGUAGE.spanish : PAGE_LANGUAGE.english,
        pageLoadEvent: 'prodLoad',
        pageName: '',
        byodDeviceType: '',
        byodCarrier: '',
        byodResult: '',
        device: [{}]
    }
};

export const DEVICES: string = 'Devices';
export const DEVICE_LANDING: string = 'Landing';
export const DEVICE_DETAILS: string = 'Details';

export enum eligibilityStatus {
    ELIGIBLE_NO_FEE_EARLY_UPGRADE = 'Eligible for a no fee early upgrade',
    ELIGIBLE_EARLY_UPGRADE = 'Eligible for an early upgrade',
    ELIGIBLE_UPGRADE = 'Eligible for an upgrade',
    INELIGIBLE_FOR_UPGRADE = 'Not eligible'
}

export enum CUSTOMER_TYPE {
    new = 'new',
    existing = 'existing'
}

export enum ACCOUNT_TYPE {
    main = 'Main',
    sub = 'Sub'
}

export enum AUTHENTICATION_STATUS {
    authenticated = 'authenticated',
    unauthenticated = 'unauthenticated'
}

export const SECONDARY_USER: string = 'secondary-user';

export const DEFAULT_SITE_INFO: TDDSiteInfo = {
    server: 'XFINITY-MOBILE',
    sessionID: '',
    siteType: 'residential',
    siteVersion: 'modestoResponsive',
    visitorID: ''
};

export const DEFAULT_USERS: TDDUser[] = [
    {
        profile: [
            {
                profileInfo: {
                    authenticationStatus: AUTHENTICATION_STATUS.unauthenticated,
                    customerType: CUSTOMER_TYPE.new,
                    accountType: '',
                    userGUID: '',
                    custGUID: '',
                    mobilePlanType: '',
                    isMobileCustomer: 'No'
                }
            }
        ]
    }
];

export const DEFAULT_CART: TDDCart = {
    attribute: {
        isOfferInCart: 'no',
        offerInCart: ''
    },
    cartId: '',
    products: {
        productInfo: []
    }
};

export const DTM_SEND_EVENT: string = 'send-Event';
export const LINE_OF_BUSINESS: string = 'XFINITY Mobile';
export const CUSTOM_CLICK_EVENT: string = 'click';
export const CUSTOM_BUTTON_CLICK_EVENT: string = 'button click';
export const ID_IDENTIFER: string = 'key.';

export const ONE_TIME_PAYMENT_AMOUNT_EVENT: string = 'partial-payment-amount';
export const PAST_DUE_PAYMENT_AMOUNT_EVENT: string = 'pastdue-payment-amount';

export const LINE_TRANSFER: string = 'Line-transfer';

export enum CustomizerPhone {
    BUYFLOW_STEP = 'Phone Customizer',
    BUTTON_TYPE = 'Click Continue Customizer'
}

export enum CustomizerAccessory {
    BUYFLOW_STEP = 'Accessory Customizer',
    BUTTON_TYPE = 'Click Continue Customizer'
}

export enum ConfirmationAttributes {
    BUYFLOW_STEP = 'Confirmation',
    BUYFLOW_TYPE = 'Standard modesto buyflow'
}

export enum CheckoutAttributes {
    BUYFLOW_STEP = 'checkout',
    BUYFLOW_TYPE = 'Standard modesto buyflow'
}

/**
 * A blacklist of states for which we need to prevent the
 * analytics page view tracking call during transition.
 *
 * Being used in the onload() function of the analytics service.
 */
export const PREVENT_PAGEVIEW_ROUTES: string[] = [
    'checkout.eligibility',
    'shop.device',
    'shop.accessory',
    'shop.tablet',
    'shop.watch',
    'shop.customize'
];

export const QUICKPAY_MDN_LOOKUP_EVENT: string = 'quickpay-account-lookup';
export const DEFAULT_EVENT: TDigitalEvent[] = [];

/**
 * Events should be inserted upon requirements with basic structure like:
 *
 * events: [
 *      {
 *          eventName: '', // should be same as eventName to be fired.
 *          name: 'event name',
 *          action: 'event action',
 *          page: 'event pipified page route',
 *          dtmEvent: '' // If required - Direct Call rule for DTM Tracking
 *       }
 * ]
 */
export const CUSTOM_EVENTS: TDDEvents = {
    events: [
        {
            eventName: 'General Search',
            name: 'button click',
            action: 'Search',
            dtmEvent: 'custom-SupportSearch'
        },
        {
            eventName: 'Login',
            action: 'Login',
            dtmEvent: 'loginEvent'
        },
        {
            eventName: 'FE Error',
            dtmEvent: 'feerror'
        },
        {
            eventName: 'search-result-click',
            action: 'Search Results Click',
            dtmEvent: 'searchResultClick'
        },
        {
            eventName: 'pending-balance-payment-amount',
            dtmEvent: 'Pending Balance Payment Amount'
        },
        {
            eventName: 'pending-balance-payment-card',
            dtmEvent: 'Pending Balance Payment Card'
        },
        {
            eventName: 'pending-balance-payment-review',
            dtmEvent: 'Pending Balance Payment Review'
        },
        {
            eventName: 'pending-balance-payment-confirmation',
            dtmEvent: 'Pending Balance Payment Confirmation'
        },
        {
            eventName: 'pastdue-payment-amount',
            dtmEvent: 'Pastdue Payment Amount'
        },
        {
            eventName: 'pastdue-payment-card',
            dtmEvent: 'Pastdue Payment Card'
        },
        {
            eventName: 'pastdue-payment-review',
            dtmEvent: 'Pastdue Payment Review'
        },
        {
            eventName: 'pastdue-payment-confirmation',
            dtmEvent: 'Pastdue Payment Confirmation'
        },
        {
            eventName: 'quickpay-account-lookup',
            dtmEvent: 'QuickPay account lookup'
        },
        {
            eventName: 'quickpay-payment-amount',
            dtmEvent: 'Payment Amount'
        },
        {
            eventName: 'quickpay-payment-method',
            dtmEvent: 'QuickPay Payment Method'
        },
        {
            eventName: 'quickpay-review',
            dtmEvent: 'QuickPay Review'
        },
        {
            eventName: 'quickpay-confirmation',
            dtmEvent: 'QuickPay Confirmation'
        },
        {
            eventName: 'device-mismatch-clicked',
            dtmEvent: 'Device Mismatch'
        },
        {
            eventName: 'device-mismatch-unrecognized-clicked',
            dtmEvent: 'Device Mismatch Unrecognized'
        },
        {
            eventName: 'device-mismatch-recognized-start-clicked',
            dtmEvent: 'Device Mismatch Recognized Start'
        },
        {
            eventName: 'device-mismatch-recognized-in-progress-clicked',
            dtmEvent: 'Device Mismatch Recognized In Progress'
        },
        {
            eventName: 'device-mismatch-recognized-failure-clicked',
            dtmEvent: 'Device Mismatch Recognized Failure'
        },
        {
            eventName: 'device-mismatch-recognized-pending-clicked',
            dtmEvent: 'Device Mismatch Recognized Pending'
        },
        {
            eventName: 'device-mismatch-recognized-success-clicked',
            dtmEvent: 'Device Mismatch Recognized Success'
        },
        {
            eventName: 'rate-search',
            dtmEvent: 'Rate Search'
        },
        {
            eventName: 'byod-activation-failure',
            dtmEvent: 'Byod Activation Failure'
        },
        {
            eventName: 'activation-failure',
            dtmEvent: 'Activation Failure'
        },
        {
            eventName: 'CANCEL_LINE_TRANSFER_FAILURE',
            dtmEvent: 'Cancel Line Transfer Failure'
        },
        {
            eventName: 'REQUEST_NEW_PIN_FAILURE',
            dtmEvent: 'Request New Pin Failure'
        },
        {
            eventName: 'letzchat-translation-footer-click',
            dtmEvent: 'LetzChat Translation Footer Click'
        },
        {
            eventName: 'plan-change-review',
            dtmEvent: 'Plan Change Review'
        },
        {
            eventName: 'segment-change-review',
            dtmEvent: 'Segment Change Review'
        }
    ]
};

export enum ByodEligibilityPages {
    compatible = 'compatible',
    incompatible = 'error-incompatible',
    isApplelocked = 'error-applelocked',
    isAndroidLocked = 'error-androidlocked',
    updatesoftware = 'error-updatesoftware',
    existingline = 'error-existingline',
    lostStolen = 'error-lostStolen',
    LTEonly = 'error-LTEonly',
    SECONDARY_IMEI = 'error-secondaryIMEI'
}
